import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, vModelText as _vModelText, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "keyword-goal-editor",
  "data-testid": "marketing-campaign-keyword-editor"
}
const _hoisted_2 = { class: "keyword-goal-title-row" }
const _hoisted_3 = { class: "keyword-goal-state" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "keyword-goal-note" }
const _hoisted_6 = { class: "keyword-goal-sources" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "keyword-gsc-panel",
  "data-testid": "marketing-keyword-gsc-panel"
}
const _hoisted_10 = { class: "keyword-gsc-heading" }
const _hoisted_11 = { class: "keyword-gsc-brand" }
const _hoisted_12 = {
  key: 0,
  class: "keyword-gsc-empty"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["value", "disabled", "data-testid"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 1,
  class: "keyword-goal-empty",
  "data-testid": "marketing-keyword-empty"
}
const _hoisted_17 = { class: "keyword-goal-card-heading" }
const _hoisted_18 = {
  key: 0,
  class: "keyword-goal-draft"
}
const _hoisted_19 = ["disabled", "onClick"]
const _hoisted_20 = ["data-testid"]
const _hoisted_21 = { class: "keyword-goal-grid" }
const _hoisted_22 = { class: "wide" }
const _hoisted_23 = ["onUpdate:modelValue", "disabled"]
const _hoisted_24 = ["onUpdate:modelValue", "disabled"]
const _hoisted_25 = { class: "full" }
const _hoisted_26 = ["onUpdate:modelValue", "disabled", "data-testid"]
const _hoisted_27 = ["disabled", "data-testid", "onClick"]
const _hoisted_28 = { class: "full" }
const _hoisted_29 = ["onUpdate:modelValue", "placeholder", "disabled"]
const _hoisted_30 = ["data-testid"]
const _hoisted_31 = { class: "keyword-goal-grid" }
const _hoisted_32 = ["onUpdate:modelValue", "disabled"]
const _hoisted_33 = ["onUpdate:modelValue", "disabled"]
const _hoisted_34 = ["onUpdate:modelValue", "disabled"]
const _hoisted_35 = { class: "wide" }
const _hoisted_36 = ["onUpdate:modelValue", "disabled"]
const _hoisted_37 = ["onUpdate:modelValue", "disabled"]
const _hoisted_38 = { class: "wide" }
const _hoisted_39 = ["onUpdate:modelValue", "disabled"]
const _hoisted_40 = { class: "wide" }
const _hoisted_41 = ["onUpdate:modelValue", "disabled"]
const _hoisted_42 = ["onUpdate:modelValue", "disabled"]
const _hoisted_43 = ["onUpdate:modelValue", "disabled"]
const _hoisted_44 = ["onUpdate:modelValue", "disabled"]
const _hoisted_45 = ["onUpdate:modelValue", "disabled"]
const _hoisted_46 = ["onUpdate:modelValue", "disabled"]
const _hoisted_47 = ["onUpdate:modelValue", "disabled"]
const _hoisted_48 = ["value"]
const _hoisted_49 = ["onUpdate:modelValue", "disabled"]
const _hoisted_50 = ["onUpdate:modelValue", "disabled"]
const _hoisted_51 = ["onUpdate:modelValue", "disabled"]
const _hoisted_52 = ["onUpdate:modelValue", "disabled"]
const _hoisted_53 = { class: "wide" }
const _hoisted_54 = ["onUpdate:modelValue", "disabled"]
const _hoisted_55 = { class: "wide" }
const _hoisted_56 = ["onUpdate:modelValue", "disabled"]
const _hoisted_57 = { class: "wide" }
const _hoisted_58 = ["onUpdate:modelValue", "disabled"]
const _hoisted_59 = { class: "wide" }
const _hoisted_60 = ["onUpdate:modelValue", "disabled"]
const _hoisted_61 = { class: "full" }
const _hoisted_62 = ["onUpdate:modelValue", "disabled"]
const _hoisted_63 = ["disabled"]
const _hoisted_64 = { class: "keyword-goal-settings" }
const _hoisted_65 = { class: "keyword-goal-grid settings" }
const _hoisted_66 = ["onUpdate:modelValue", "disabled"]
const _hoisted_67 = ["disabled"]
const _hoisted_68 = ["disabled"]
const _hoisted_69 = { class: "keyword-goal-actions" }
const _hoisted_70 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _cache[10] || (_cache[10] = _createElementVNode("h2", null, "獲得目標キーワード", -1)),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.targets.length) + "件", 1)
        ]),
        _cache[11] || (_cache[11] = _createElementVNode("p", null, " 必須は「キーワード」「想定読者と悩み」「対象ページURL」の3つだけです（最終成果は施策全体の設定を使います）。 検索意図・JTBDなどは「詳細入力（任意）」で、入力するとレポートとAI記事作成ブリーフの読者理解が細かくなります。 ", -1))
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "secondary",
        disabled: _ctx.saving,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
      }, "保存前の状態に戻す", 8, _hoisted_4)
    ]),
    _createElementVNode("p", _hoisted_5, [
      _cache[12] || (_cache[12] = _createTextVNode(" レポートは生成を依頼した時点の設定を保存します。既存の保存済みレポートは、この画面を変更しても変わりません。 ", -1)),
      (_ctx.localPlanning)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("本番同期中の施策のため、この設定はこの環境だけに保存され、「本番ログをローカル保存」でも上書きされません。")
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        type: "button",
        class: "secondary",
        disabled: _ctx.saving || !_ctx.writable || _ctx.targets.length >= _ctx.maxTargets,
        "data-testid": "marketing-keyword-add-template",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addStrategyTemplates && _ctx.addStrategyTemplates(...args)))
      }, " 戦略テンプレートから追加 ", 8, _hoisted_7),
      (_ctx.gscEnabled)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "secondary",
            disabled: _ctx.saving || !_ctx.writable || _ctx.gscLoading,
            "data-testid": "marketing-keyword-gsc-open",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleGscCandidates && _ctx.toggleGscCandidates(...args)))
          }, _toDisplayString(_ctx.gscLoading ? "検索語を取得中..." : "GSCで観測された検索語から追加"), 9, _hoisted_8))
        : _createCommentVNode("", true)
    ]),
    (_ctx.gscPanelOpen)
      ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("strong", null, "GSCで観測された検索語（" + _toDisplayString(_ctx.gscPeriodLabel) + "、表示回数順・最大" + _toDisplayString(_ctx.gscCandidateLimit) + "件）", 1),
            _createElementVNode("label", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.excludeBrandQueries) = $event)),
                type: "checkbox",
                "data-testid": "marketing-keyword-gsc-exclude-brand"
              }, null, 512), [
                [_vModelCheckbox, _ctx.excludeBrandQueries]
              ]),
              _cache[13] || (_cache[13] = _createTextVNode(" 指名語を除外 ", -1))
            ])
          ]),
          (_ctx.visibleGscCandidates.length == 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_12, "表示できる検索語がありません。GSCの接続・同期状態を確認してください。"))
            : (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleGscCandidates, (candidate) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: candidate.query
                  }, [
                    _createElementVNode("label", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedGscQueries) = $event)),
                        type: "checkbox",
                        value: candidate.query,
                        disabled: candidate.registered,
                        "data-testid": `marketing-keyword-gsc-candidate-${candidate.query}`
                      }, null, 8, _hoisted_14), [
                        [_vModelCheckbox, _ctx.selectedGscQueries]
                      ]),
                      _createElementVNode("span", null, _toDisplayString(candidate.query), 1),
                      _createElementVNode("small", null, [
                        _createTextVNode("表示 " + _toDisplayString(_ctx.formatCount(candidate.impressions)) + "・クリック " + _toDisplayString(_ctx.formatCount(candidate.clicks)), 1),
                        (candidate.brand)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" ・指名語")
                            ], 64))
                          : _createCommentVNode("", true),
                        (candidate.registered)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" ・登録済み")
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128))
              ])),
          _createElementVNode("button", {
            type: "button",
            disabled: _ctx.selectedGscQueries.length == 0 || _ctx.saving || !_ctx.writable,
            "data-testid": "marketing-keyword-gsc-add",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addGscCandidates && _ctx.addGscCandidates(...args)))
          }, " 選んだ検索語を下書きに追加 ", 8, _hoisted_15)
        ]))
      : _createCommentVNode("", true),
    (_ctx.targets.length == 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_16, " 獲得目標キーワードはまだ登録されていません。「戦略テンプレートから追加」で6件の下書きを入れるか、下の「目標キーワードを追加」で入力欄を出してください。 "))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targets, (target, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `keyword_goal_${index}`,
        class: "keyword-goal-card"
      }, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("strong", null, [
            _createTextVNode("目標 " + _toDisplayString(index + 1), 1),
            (target._draft)
              ? (_openBlock(), _createElementBlock("em", _hoisted_18, "未保存"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "danger-text",
            disabled: _ctx.saving || !_ctx.writable,
            onClick: ($event: any) => (_ctx.removeTarget(index))
          }, "削除", 8, _hoisted_19)
        ]),
        (_ctx.missingLabels(target).length > 0)
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: "keyword-goal-missing",
              "data-testid": `marketing-keyword-missing-${index}`
            }, " 不足：" + _toDisplayString(_ctx.missingLabels(target).join("、")), 9, _hoisted_20))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("label", _hoisted_22, [
            _cache[14] || (_cache[14] = _createElementVNode("span", null, [
              _createTextVNode("キーワード"),
              _createElementVNode("em", { class: "keyword-goal-required" }, "必須")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": ($event: any) => ((target.keyword) = $event),
              placeholder: "例: 人材紹介 日程調整",
              disabled: _ctx.saving || !_ctx.writable
            }, null, 8, _hoisted_23), [
              [_vModelText, target.keyword]
            ])
          ]),
          _createElementVNode("label", null, [
            _cache[16] || (_cache[16] = _createElementVNode("span", null, "優先度", -1)),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": ($event: any) => ((target.priority) = $event),
              disabled: _ctx.saving || !_ctx.writable
            }, [...(_cache[15] || (_cache[15] = [
              _createElementVNode("option", { value: "high" }, "高", -1),
              _createElementVNode("option", { value: "medium" }, "中", -1),
              _createElementVNode("option", { value: "low" }, "低", -1)
            ]))], 8, _hoisted_24), [
              [_vModelSelect, target.priority]
            ])
          ]),
          _createElementVNode("label", _hoisted_25, [
            _cache[17] || (_cache[17] = _createElementVNode("span", null, [
              _createTextVNode("想定読者と悩み"),
              _createElementVNode("em", { class: "keyword-goal-required" }, "必須")
            ], -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": ($event: any) => ((target.anticipated_user) = $event),
              rows: "2",
              placeholder: "誰が・何に困って検索するかを1〜2文で（例: 人材紹介会社のアドバイザーが、候補者と企業の面談日程が決まらず困っている）",
              disabled: _ctx.saving || !_ctx.writable,
              "data-testid": `marketing-keyword-anticipated-user-${index}`
            }, null, 8, _hoisted_26), [
              [_vModelText, target.anticipated_user]
            ]),
            (!`${target.anticipated_user || ''}`.trim())
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "keyword-goal-draft-button",
                  disabled: _ctx.saving || !_ctx.writable || !`${target.keyword || ''}`.trim() || _ctx.audienceDrafting,
                  "data-testid": `marketing-keyword-audience-draft-${index}`,
                  onClick: ($event: any) => (_ctx.insertAudienceDraft(index))
                }, " 下書きを入れる（キーワード・対象ページ・施策目標のCEPから推測） ", 8, _hoisted_27))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("label", _hoisted_28, [
            _cache[18] || (_cache[18] = _createElementVNode("span", null, [
              _createTextVNode("対象ページURL"),
              _createElementVNode("em", { class: "keyword-goal-required" }, "必須")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": ($event: any) => ((target.target_page_url) = $event),
              placeholder: target._target_page_url_placeholder || '記事から誘導したいページ（例: https://link.waaq.jp/chukai_agent）',
              disabled: _ctx.saving || !_ctx.writable
            }, null, 8, _hoisted_29), [
              [_vModelText, target.target_page_url]
            ])
          ])
        ]),
        _createElementVNode("details", {
          class: "keyword-goal-details",
          "data-testid": `marketing-keyword-details-${index}`
        }, [
          _createElementVNode("summary", null, "詳細入力（任意）・入力済み " + _toDisplayString(_ctx.filledDetailCount(target)) + " / " + _toDisplayString(_ctx.detailFieldCount) + " 項目", 1),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("label", null, [
              _cache[19] || (_cache[19] = _createElementVNode("span", null, "キーワードクラスタ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((target.keyword_cluster) = $event),
                placeholder: "例: 人材紹介の三者間調整",
                disabled: _ctx.saving || !_ctx.writable
              }, null, 8, _hoisted_32), [
                [_vModelText, target.keyword_cluster]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[21] || (_cache[21] = _createElementVNode("span", null, "検索意図", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": ($event: any) => ((target.search_intent) = $event),
                disabled: _ctx.saving || !_ctx.writable
              }, [...(_cache[20] || (_cache[20] = [
                _createStaticVNode("<option value=\"\" data-v-31be33fc>自動判定</option><option value=\"named\" data-v-31be33fc>指名</option><option value=\"comparison\" data-v-31be33fc>比較・選定</option><option value=\"method\" data-v-31be33fc>方法</option><option value=\"problem\" data-v-31be33fc>課題</option><option value=\"implementation\" data-v-31be33fc>導入</option><option value=\"service\" data-v-31be33fc>サービス</option><option value=\"informational\" data-v-31be33fc>情報収集</option><option value=\"other\" data-v-31be33fc>その他</option>", 9)
              ]))], 8, _hoisted_33), [
                [_vModelSelect, target.search_intent]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[23] || (_cache[23] = _createElementVNode("span", null, "検討段階", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": ($event: any) => ((target.purchase_stage) = $event),
                disabled: _ctx.saving || !_ctx.writable
              }, [...(_cache[22] || (_cache[22] = [
                _createStaticVNode("<option value=\"\" data-v-31be33fc>未設定</option><option value=\"awareness\" data-v-31be33fc>認知</option><option value=\"consideration\" data-v-31be33fc>検討</option><option value=\"comparison\" data-v-31be33fc>比較</option><option value=\"decision\" data-v-31be33fc>意思決定</option><option value=\"existing_customer\" data-v-31be33fc>既存顧客</option>", 6)
              ]))], 8, _hoisted_34), [
                [_vModelSelect, target.purchase_stage]
              ])
            ]),
            _createElementVNode("label", _hoisted_35, [
              _cache[24] || (_cache[24] = _createElementVNode("span", null, "検索する状況", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": ($event: any) => ((target.search_context) = $event),
                rows: "2",
                placeholder: "いつ、何が起きて検索するか",
                disabled: _ctx.saving || !_ctx.writable
              }, null, 8, _hoisted_36), [
                [_vModelText, target.search_context]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[26] || (_cache[26] = _createElementVNode("span", null, "ブランド区分", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": ($event: any) => ((target.brand_segment) = $event),
                disabled: _ctx.saving || !_ctx.writable
              }, [...(_cache[25] || (_cache[25] = [
                _createElementVNode("option", { value: "non_brand" }, "非ブランド", -1),
                _createElementVNode("option", { value: "brand" }, "ブランド", -1)
              ]))], 8, _hoisted_37), [
                [_vModelSelect, target.brand_segment]
              ])
            ]),
            _createElementVNode("label", _hoisted_38, [
              _cache[27] || (_cache[27] = _createElementVNode("span", null, "達成したい仕事（JTBD）", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": ($event: any) => ((target.job_to_be_done) = $event),
                rows: "2",
                placeholder: "ユーザーが片付けたい仕事",
                disabled: _ctx.saving || !_ctx.writable
              }, null, 8, _hoisted_39), [
                [_vModelText, target.job_to_be_done]
              ])
            ]),
            _createElementVNode("label", _hoisted_40, [
              _cache[28] || (_cache[28] = _createElementVNode("span", null, "期待する答え", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": ($event: any) => ((target.expected_answer) = $event),
                rows: "2",
                placeholder: "検索結果で最初に答える内容",
                disabled: _ctx.saving || !_ctx.writable
              }, null, 8, _hoisted_41), [
                [_vModelText, target.expected_answer]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[29] || (_cache[29] = _createElementVNode("span", null, "痛み（1行1件）", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": ($event: any) => ((target.pains_text) = $event),
                rows: "3",
                disabled: _ctx.saving || !_ctx.writable
              }, null, 8, _hoisted_42), [
                [_vModelText, target.pains_text]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[30] || (_cache[30] = _createElementVNode("span", null, "障壁（1行1件）", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": ($event: any) => ((target.barriers_text) = $event),
                rows: "3",
                disabled: _ctx.saving || !_ctx.writable
              }, null, 8, _hoisted_43), [
                [_vModelText, target.barriers_text]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[31] || (_cache[31] = _createElementVNode("span", null, "不安（1行1件）", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": ($event: any) => ((target.anxieties_text) = $event),
                rows: "3",
                disabled: _ctx.saving || !_ctx.writable
              }, null, 8, _hoisted_44), [
                [_vModelText, target.anxieties_text]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[32] || (_cache[32] = _createElementVNode("span", null, "反論（1行1件）", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": ($event: any) => ((target.objections_text) = $event),
                rows: "3",
                disabled: _ctx.saving || !_ctx.writable
              }, null, 8, _hoisted_45), [
                [_vModelText, target.objections_text]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[34] || (_cache[34] = _createElementVNode("span", null, "対象ページ種別", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": ($event: any) => ((target.target_page_scope) = $event),
                disabled: _ctx.saving || !_ctx.writable
              }, [...(_cache[33] || (_cache[33] = [
                _createStaticVNode("<option value=\"\" data-v-31be33fc>自動判定</option><option value=\"service_lp\" data-v-31be33fc>サービスLP</option><option value=\"blog_article\" data-v-31be33fc>ブログ記事</option><option value=\"comparison_article\" data-v-31be33fc>比較記事</option><option value=\"corporate\" data-v-31be33fc>会社・採用</option><option value=\"other\" data-v-31be33fc>その他</option>", 6)
              ]))], 8, _hoisted_46), [
                [_vModelSelect, target.target_page_scope]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[36] || (_cache[36] = _createElementVNode("span", null, "このキーワードの最終成果", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": ($event: any) => ((target.final_conversion_event) = $event),
                disabled: _ctx.saving || !_ctx.writable
              }, [
                _cache[35] || (_cache[35] = _createElementVNode("option", { value: "" }, "施策全体の設定を使用", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventOptions, (event) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: event.value,
                    value: event.value
                  }, _toDisplayString(event.label), 9, _hoisted_48))
                }), 128))
              ], 8, _hoisted_47), [
                [_vModelSelect, target.final_conversion_event]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[37] || (_cache[37] = _createElementVNode("span", null, "事業関連度（0〜100）", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((target.business_relevance) = $event),
                type: "number",
                min: "0",
                max: "100",
                disabled: _ctx.saving || !_ctx.writable
              }, null, 8, _hoisted_49), [
                [
                  _vModelText,
                  target.business_relevance,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[38] || (_cache[38] = _createElementVNode("span", null, "サービス適合度（0〜100）", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((target.service_fit) = $event),
                type: "number",
                min: "0",
                max: "100",
                disabled: _ctx.saving || !_ctx.writable
              }, null, 8, _hoisted_50), [
                [
                  _vModelText,
                  target.service_fit,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[39] || (_cache[39] = _createElementVNode("span", null, "目標順位", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((target.target_position) = $event),
                type: "number",
                min: "1",
                max: "100",
                step: "0.1",
                disabled: _ctx.saving || !_ctx.writable
              }, null, 8, _hoisted_51), [
                [
                  _vModelText,
                  target.target_position,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[40] || (_cache[40] = _createElementVNode("span", null, "目標CTR（%）", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((target.target_ctr_percent) = $event),
                type: "number",
                min: "0",
                max: "100",
                step: "0.1",
                disabled: _ctx.saving || !_ctx.writable
              }, null, 8, _hoisted_52), [
                [
                  _vModelText,
                  target.target_ctr_percent,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("label", _hoisted_53, [
              _cache[41] || (_cache[41] = _createElementVNode("span", null, "除外語（1行1件）", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": ($event: any) => ((target.excluded_terms_text) = $event),
                rows: "2",
                disabled: _ctx.saving || !_ctx.writable
              }, null, 8, _hoisted_54), [
                [_vModelText, target.excluded_terms_text]
              ])
            ]),
            _createElementVNode("label", _hoisted_55, [
              _cache[42] || (_cache[42] = _createElementVNode("span", null, "対象外の検索意図（1行1件）", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": ($event: any) => ((target.non_target_intents_text) = $event),
                rows: "2",
                disabled: _ctx.saving || !_ctx.writable
              }, null, 8, _hoisted_56), [
                [_vModelText, target.non_target_intents_text]
              ])
            ]),
            _createElementVNode("label", _hoisted_57, [
              _cache[43] || (_cache[43] = _createElementVNode("span", null, "判断根拠", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": ($event: any) => ((target.decision_evidence) = $event),
                rows: "2",
                disabled: _ctx.saving || !_ctx.writable,
                "data-testid": "marketing-keyword-decision-evidence"
              }, null, 8, _hoisted_58), [
                [_vModelText, target.decision_evidence]
              ])
            ]),
            _createElementVNode("label", _hoisted_59, [
              _cache[44] || (_cache[44] = _createElementVNode("span", null, "確認方法", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": ($event: any) => ((target.verification_method) = $event),
                rows: "2",
                disabled: _ctx.saving || !_ctx.writable,
                "data-testid": "marketing-keyword-verification-method"
              }, null, 8, _hoisted_60), [
                [_vModelText, target.verification_method]
              ])
            ]),
            _createElementVNode("label", _hoisted_61, [
              _cache[45] || (_cache[45] = _createElementVNode("span", null, "メモ", -1)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": ($event: any) => ((target.memo) = $event),
                rows: "2",
                placeholder: "狙う理由や変更しない条件",
                disabled: _ctx.saving || !_ctx.writable
              }, null, 8, _hoisted_62), [
                [_vModelText, target.memo]
              ])
            ])
          ])
        ], 8, _hoisted_30)
      ]))
    }), 128)),
    (_ctx.targets.length < _ctx.maxTargets)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          type: "button",
          class: "secondary add-target",
          disabled: _ctx.saving || !_ctx.writable,
          "data-testid": "marketing-keyword-add",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addTarget && _ctx.addTarget(...args)))
        }, " 目標キーワードを追加 ", 8, _hoisted_63))
      : _createCommentVNode("", true),
    _createElementVNode("details", _hoisted_64, [
      _cache[48] || (_cache[48] = _createElementVNode("summary", null, "改善余地の試算基準", -1)),
      _cache[49] || (_cache[49] = _createElementVNode("p", null, "アカウント内の順位帯別実績が少ないときだけ使うCTR基準です。", -1)),
      _createElementVNode("div", _hoisted_65, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctrBands, (band) => {
          return (_openBlock(), _createElementBlock("label", {
            key: band.key
          }, [
            _createElementVNode("span", null, _toDisplayString(band.label) + " CTR（%）", 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": ($event: any) => ((_ctx.settings.fallback_ctr_percent[band.key]) = $event),
              type: "number",
              min: "0",
              max: "100",
              step: "0.1",
              disabled: _ctx.saving || !_ctx.writable
            }, null, 8, _hoisted_66), [
              [
                _vModelText,
                _ctx.settings.fallback_ctr_percent[band.key],
                void 0,
                { number: true }
              ]
            ])
          ]))
        }), 128)),
        _createElementVNode("label", null, [
          _cache[46] || (_cache[46] = _createElementVNode("span", null, "最低表示回数", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.settings.minimum_benchmark_impressions) = $event)),
            type: "number",
            min: "20",
            max: "1000000",
            disabled: _ctx.saving || !_ctx.writable
          }, null, 8, _hoisted_67), [
            [
              _vModelText,
              _ctx.settings.minimum_benchmark_impressions,
              void 0,
              { number: true }
            ]
          ])
        ]),
        _createElementVNode("label", null, [
          _cache[47] || (_cache[47] = _createElementVNode("span", null, "最低検索語数", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.settings.minimum_benchmark_queries) = $event)),
            type: "number",
            min: "1",
            max: "100",
            disabled: _ctx.saving || !_ctx.writable
          }, null, 8, _hoisted_68), [
            [
              _vModelText,
              _ctx.settings.minimum_benchmark_queries,
              void 0,
              { number: true }
            ]
          ])
        ])
      ])
    ]),
    (_ctx.statusMessage)
      ? (_openBlock(), _createElementBlock("p", {
          key: 3,
          class: _normalizeClass(['keyword-goal-message', _ctx.statusKind]),
          role: "status"
        }, _toDisplayString(_ctx.statusMessage), 3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_69, [
      _createElementVNode("button", {
        type: "button",
        disabled: !_ctx.canSave,
        "data-testid": "marketing-keyword-save",
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
      }, _toDisplayString(_ctx.saving ? "保存中..." : "キーワード目標を保存"), 9, _hoisted_70)
    ])
  ]))
}